




























import {Component, PropSync, Watch} from 'vue-property-decorator'
import {Getter, Action} from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import {SelectWings, ToggleWings, FilterWings, FilterSelectedItemWings} from 'wings-ui-components';
import {DistributionFilter} from "@/store/templates/types";
import {notifyError, notifyWarning} from "@/utils/notify-helper";
import { getTranslatedParams } from '@/utils/notify-utils';

@Component({components: {FilterSelectedItemWings, SelectWings, ToggleWings, FilterWings}})
export default class DistributionsFilter extends BaseFilter<DistributionFilter> {
  @PropSync('show') is_show!: boolean;
  @PropSync("filterClone") propFilterClone!: any;
  @PropSync('runFilter') propRunFilter!: boolean;
  @Action("getDistributions") actionGetDistributions: any;
  @Action("actionLog") actionLog: any;

  statuses = [
    'GENERATED', 'PAYMENT_WAITING', 'IN_PROGRESS', 'ON_MODERATION', 'DENIED', 'PAUSED', 'STOPPED', 'ERROR', 'FINISHED'
  ]
  log: boolean = false

  defaultFilter(): DistributionFilter {
    return {
      name: undefined,
      transport: undefined,
      status: undefined,
      comment: undefined,
    }
  }

  created() {
    this.filtered();
    this.scroll();
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Viewing",
        actionStatus: 'success',
        objectType: "Distribution",
        addititionalInfo: getTranslatedParams(this.filter)
      }
      const resp = await this.actionGetDistributions(this.filter);
      if (this.log && !nextPage) await this.actionLog(this.logObject)
      this.log = true
      if (resp.data.length == 0) {
        if (!nextPage) notifyWarning()
        this.is_last = true
      } else {
        this.is_last = false
      }
    } catch(error) {
      notifyError(error);
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    } finally {
      this.moreLoading = false
    }
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChange(val: any) {
    this.propFilterClone = val;
  }

  @Watch('runFilter')
  onRunFilterChange(val: boolean) {
    if (!val) return;
    this.filtered();
    this.propRunFilter = false;
  }

  unsetFilter(field: string): void {
    let defaultFilter: any = this.defaultFilter();
    this.$set(this.filter, field, defaultFilter[field]);
    this.$set(this.sendFilter, field, defaultFilter[field]);
    this.$set(this.filter, 'page_number', 1);
    this.filtered();
  }

}
